import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="section footer">
      <p className="label title">
        Contact:
      </p>
      <div className="row content">
        <div className="row details">
          <a href="tel:+491704334594">Phone: +49 (0)170 433 45 94</a>
        </div>
        <div className="row">
          <a href="mailto:hello@niklasmay.com">Mail: hello@niklas-may.de</a>
        </div>
      </div>
    </div>
  )
}

export default Footer